import clsx from 'clsx';
import { useEffect, useRef } from 'react';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import {
  FILTER_DROPDOWN_SIZES,
  FILTER_FIELD_PRESENCE,
  getFilterDropdownStyle,
  PRESENCE_FILTER_OPTIONS,
} from '../consts';
import styles from './PresenceFilterDropdown.module.scss';

interface PresenceFilterDropdownProps {
  onClose: () => void;
  selectedValue: string;
  onSelect: (value: string) => void;
}

export const PresenceFilterDropdown = ({ onClose, selectedValue, onSelect }: PresenceFilterDropdownProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onDocumentMouseDown = (event: MouseEvent) => {
      if (!dropdownRef.current) return;
      if (dropdownRef.current.contains(event.target as Node)) return;
      onClose();
    };

    document.addEventListener('mousedown', onDocumentMouseDown);
    return () => {
      document.removeEventListener('mousedown', onDocumentMouseDown);
    };
  }, [onClose]);

  return (
    <div
      className={styles.dropdown}
      style={getFilterDropdownStyle(FILTER_DROPDOWN_SIZES[FILTER_FIELD_PRESENCE])}
      ref={dropdownRef}
    >
      {PRESENCE_FILTER_OPTIONS.map((item) => (
        <UnstyledButton
          key={item.value}
          className={clsx(styles.option, selectedValue === item.value && styles.optionSelected)}
          onClick={() => {
            onSelect(item.value);
            onClose();
          }}
        >
          <span>{item.label}</span>
        </UnstyledButton>
      ))}
    </div>
  );
};
